import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js";

// Connects to data-controller="attendance-rules--list"
export default class extends Controller {
  edit(event) {
    event.preventDefault();
    this.element.querySelectorAll(".list-row").forEach(item => {
      item.classList.remove("selected");
    });

    event.currentTarget.classList.add("selected");

    const editPath = event.currentTarget.dataset.editPath;

    get(editPath, {
      responseKind: "turbo-stream"
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html));
  }
}
